"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCredentials = exports.getGqlUrl = void 0;
var atoz_shiftapp_initializer_1 = require("@amzn/atoz-shiftapp-initializer");
var consts_1 = require("../../consts");
var getGqlUrl = function (stage, region, employeeId) {
    if (employeeId) {
        return "".concat(consts_1.gqlUrl[region][stage], "?employeeId=").concat(employeeId);
    }
    return consts_1.gqlUrl[region][stage];
};
exports.getGqlUrl = getGqlUrl;
var getCredentials = function (stage) {
    if (stage === atoz_shiftapp_initializer_1.Stage.DEV) {
        return 'same-origin';
    }
    return 'include';
};
exports.getCredentials = getCredentials;
